"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {};


//////////////////
// WEBPACK FOOTER
// ./~/react-stockcharts/lib/utils/noop.js
// module id = 93
// module chunks = 0